import { render, staticRenderFns } from "./myMessageSelect.vue?vue&type=template&id=e7e272d4&scoped=true"
import script from "./myMessageSelect.vue?vue&type=script&lang=js"
export * from "./myMessageSelect.vue?vue&type=script&lang=js"
import style0 from "./myMessageSelect.vue?vue&type=style&index=0&id=e7e272d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e272d4",
  null
  
)

export default component.exports